import { useQuery } from '@tanstack/react-query';
import { getDataPromise } from 'brock-fetch-utils';
import { getUri } from './getUri';

export default function useDefaultPage() {
    const { data: defaultPage, ...payload } = useQuery({
        queryKey: ['defaultPage'],
        queryFn: () => getDataPromise(getUri(`Configuration/getDefaultPage`)),
        staleTime: Infinity,
    });

    return { defaultPage, ...payload };
}
